import React, { useEffect, useRef,useState } from 'react';
import axios from 'axios';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Table, Button, Form } from 'react-bootstrap';
import swal from 'sweetalert';
import { Tab, Nav, Dropdown } from 'react-bootstrap';
import {Modal} from 'react-bootstrap';
import InviteCustomer from './AddServcies';
import InviteCustomer2 from './AddParts';
import { ToastContainer, toast } from 'react-toastify';

const EditRepairOrder = () => {
    const { repairOrderId } = useParams(); // Get the repair order ID from the URL
    const navigate = useNavigate();
    const [MainOrder, setMainOrder] = useState([]);
    const [technicians, setTechnicians] = useState([]); // State to hold technician list
    const [repairOrder, setRepairOrder] = useState([]);
    const [loading, setLoading] = useState(true);
    const [reastAmount, setReastAmount] = useState('')
    const [popupModal, setpopupModal] = useState(false)
    const [Err, setERrr] = useState('');
    const [Amount, setAmount] = useState('')
    const invite = useRef();
    const invite2 = useRef();
   const [checkPrice, setCheckPrice] = useState(0);
const [Discount, setDiscount] = useState(0);
const [Notes, setNotes] = useState("");

  const userdata = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata);
  const userid = userData.id;
    useEffect(() => {
  if (MainOrder) {
    setCheckPrice(MainOrder.CheckPrice || 0);
    setDiscount(MainOrder.Discount || 0);
    setNotes(MainOrder.Notes || "");
  }
}, [MainOrder]);

     const fetchTechnicians = async () => {
        try {
            const response = await axios.get(`https://subk.education.com.ly/back/api/technicians`);
            setTechnicians(response.data); // Assuming response data is a list of technicians
        } catch (error) {
            console.error('Error fetching technicians:', error);
        }
    };
    const fetchRepairOrder = async () => {
        try {
            const response = await axios.get(`https://subk.education.com.ly/back/api/repairOrder/${repairOrderId}`);
            setRepairOrder(response.data.RepairOrder.repair_details);
            setMainOrder(response.data.RepairOrder);
        setNotes(response.data.RepairOrder.Notes || "");
            console.log(response.data.RepairOrder.repair_details)
            console.log('MainOrde',response.data.RepairOrder)
            // Assuming the response data is structured correctly
            setLoading(false);
        } catch (error) {
            console.error('Error fetching repair order:', error);
            setLoading(false);
        }
    };
    // Fetch the repair order details
    useEffect(() => {
        fetchTechnicians();
        fetchRepairOrder();
     }, []);
    const handleChange = (index, event) => {
        const { name, value } = event.target;
        setRepairOrder(prevState => {
            const updatedRepairOrder = [...prevState];
            updatedRepairOrder[index] = {
                ...updatedRepairOrder[index],
                [name]: value
            };
            return updatedRepairOrder;
        });
        console.log('repairOrder', repairOrder)

    };
    // Handle input change
    const calculateCompletedServiceCost = () => {
        const totalServiceCost = MainOrder.repair_details
          .filter((detail) => detail.ServiceID !== null) // Filter details with ServiceID not null
          .reduce((sum, detail) => sum +  (parseFloat(detail.ServiceCost) || 0), 0); // Sum ServiceCost for filtered items
      
        return totalServiceCost;
      };
      const calculateCompletedPartCost = () => {
        const totalServiceCost = MainOrder.repair_details
          .filter((detail) => detail.PartID !== null) // Filter details with ServiceID not null
          .reduce((sum, detail) => sum + ((parseFloat(detail.PartCost) || 0)* detail.PartQuantities), 0); // Sum ServiceCost for filtered items
      
        return totalServiceCost;
      };
const handleAddNote = async () => {
    if (!Notes.trim()) {
        toast.error("يرجى إدخال ملاحظة");
        return;
    }

    try {
        await axios.put(
            `https://subk.education.com.ly/back/api/repairOrder/${repairOrderId}/note`,
            {
                Notes: Notes
            }
        );

        toast.success("تم إضافة الملاحظة بنجاح");

        setNotes(""); // تفريغ الحقل
        fetchRepairOrder(); // تحديث البيانات

    } catch (error) {
        toast.error("حدث خطأ أثناء الحفظ");
        console.error(error);
    }
};



      const handleSubmit = async (event) => {
        console.log(repairOrder)
        event.preventDefault();
       
      // Calculate both total costs
//   const serviceCost = calculateCompletedServiceCost();
//   const partCost = calculateCompletedPartCost();

//   // Combine both costs
//   const combinedTotalCost = serviceCost + partCost;

  // Log combined cost or set it in state
 // console.log("Combined Total Cost:", combinedTotalCost);
        // Set the combined total amount
        try {
            const response = await axios.put(`https://subk.education.com.ly/back/api/repairdetails/${repairOrderId}`, repairOrder);

            // swal("Success!", "Repair order updated successfully!", "success");
            toast.success('تم حفظ  التعديل  بنجاح!');

            // Optional: Update state with the response
            setMainOrder(response.data.RepairOrder);

            // Construct the query string
            

        } catch (error) {
                    const errorMessage = error.response ? error.response.data.message : "حدث خطأ غير متوقع.";
            console.error('Error updating repair order:', error);
        swal("خطأ!", errorMessage, "error");
}
    };
    function areAllServicesCompleted(repairDetails) {
     //   return repairDetails.every(detail => detail.Status === "Completed");
    
      return repairDetails.every(detail => detail.Status === "مكتملة" && detail.ServiceID !== null);
    }
    const Completed = async () => {
        const repairDetailsWithService = MainOrder.repair_details.filter(
            (detail) => detail.ServiceID !== null 
          );   
          
        const allCompleted = areAllServicesCompleted(repairDetailsWithService);
        if (allCompleted) {
            console.log("All services are completed.");
           // const { totalPartCost, totalServiceCost, combinedTotal } = calculateTotals();

            const error = await axios.put(`https://subk.education.com.ly/back/api/repairOrder/${repairOrderId}`, {
                ['RepairStatus']: "مكتملة", 
              //  ['TotalCost']:  combinedTotal,
                ['UserID']:userid,
             });
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                  } else if (error.request) {
                    console.log(error.request);
                  } else {
                    console.log('Error', error.message);
                  }
                  fetchRepairOrder()
        } else {

            swal("ليس  كل خدمات في حالة المكتملة ,الرجاء تغير حالة كل الخدمات وضغظ زر الحفظ  ");

            
        }
    }
const updateOrderInfo = async () => {
  try {
 const serviceCost = calculateCompletedServiceCost();
  const partCost = calculateCompletedPartCost();
//   // Combine both costs
  //const combinedTotalCost = serviceCost + partCost +parseFloat(MainOrder.CheckPrice) || 0 ;
  const combinedTotalCost =
  serviceCost +
  partCost +
  (Number(checkPrice) || 0);

    await axios.put(`https://subk.education.com.ly/back/api/repairOrder/${repairOrderId}`, {
      ['CheckPrice']: checkPrice,
      ['Discount']: Discount,
      ['Notes']: Notes,
                  ['TotalCost']:combinedTotalCost-Discount,

       ['UserID']:userid,
    });

    alert("تم تحديث البيانات بنجاح ✅");
  } catch (err) {
    console.error(err);
    alert("حدث خطأ أثناء التحديث ❌");
  } finally {
              fetchRepairOrder()
  }
};

      const disccounfun = async (e) => {
        setDiscount(e)
        const serviceCost = calculateCompletedServiceCost();
  const partCost = calculateCompletedPartCost();
//   // Combine both costs
  const combinedTotalCost = serviceCost + partCost +parseFloat(MainOrder.CheckPrice) || 0 ;
        const error = await axios.put(`https://subk.education.com.ly/back/api/repairOrder/${repairOrderId}`, {
            ['Discount']: e, 
            ['TotalCost']:combinedTotalCost-e,
                            ['UserID']:userid,

          });
            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
              } else if (error.request) {
                console.log(error.request);
              } else {
                console.log('Error', error.message);
              }
              fetchRepairOrder()
    }
    const Completed4 = async () => {
        
        const error = await axios.put(`https://subk.education.com.ly/back/api/repairOrder/${repairOrderId}`, {
            ['RepairStatus']: "قيد التنفيد", 
                            ['UserID']:userid,

          });
            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
              } else if (error.request) {
                console.log(error.request);
              } else {
                console.log('Error', error.message);
              }
              fetchRepairOrder()
    }
    if (loading) return <div>Loading...</div>;
const handleDelete = (index) => {
    swal({
        title: "هل أنت متأكد؟", // "Are you sure?"
        text: "بمجرد الحذف، لن تتمكن من استعادة هذا العنصر!", // "Once deleted, you will not be able to recover this item!"
        icon: "warning",
        buttons: true,
        dangerMode: true,
    }).then((willDelete) => {
        if (willDelete) {
            axios.delete(`https://subk.education.com.ly/back/api/repairdetails/${index}`)
                .then(res => {
                    fetchRepairOrder();
                    swal("تم حذف العنصر!", { // "The item has been deleted!"
                        icon: "success",
                    });
                });
        } else {
            swal("تم الإحتفاظ بعنصرك!"); // "Your item is safe!"
        }
    });
};

    const handleDeleteeng = (index) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this item!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                axios.delete(`https://subk.education.com.ly/back/api/repairdetails/${index}`,)

                    .then(res => {
                        fetchRepairOrder();
                        swal("The item has been deleted!", {
                            icon: "success",
                        });
                    });
            } else {
                swal("Your item is safe!");
            }
        });
    };
    function orderlist(id) {
        console.log('Prepay', MainOrder.Prepay)
       // const { totalPartCost, totalServiceCost, combinedTotal } = calculateTotals();
       console.log('TotalCost', MainOrder.TotalCost)
       setReastAmount('')
       setReastAmount(parseFloat(MainOrder.RestAmount) || 0)
       setERrr('')
setpopupModal(true)
        }
        const handleEdit = async  () => {
            setERrr('');
      if(Amount > reastAmount) {
        setERrr('القيمة المدخلة اكبر من القيمة المتبقية')
      }else{
        const response = await  axios.post(`https://subk.education.com.ly/back/api/invoices`, {
               ['Amount']: Amount,
               ['Status']: 'تم الدفع',
               ['RepairStatus']: 'تم التسليم',
               ['RepairOrderID']: repairOrderId,
             //  ['RestAmount']:reastAmount,
      
                });
                setMainOrder(response.data.RepairOrder);

                // Construct the query string
                const SecqueryString = new URLSearchParams({
                    data2: JSON.stringify(response.data.RepairOrder.invoice), // Ensure safe URL encoding

                    data: JSON.stringify(response.data.RepairOrder.repair_details), // Ensure safe URL encoding
                    name: response.data.RepairOrder.customer.FirstName,
                    RefNmber: '101101',
                    TotalCost: response.data.RepairOrder.TotalCost,
                    Vehicle: response.data.RepairOrder.vehicle.LicensePlate,
                    RepairDate: response.data.RepairOrder.RepairDate,
                }).toString();
                console.log('SecqueryString', SecqueryString)
                // Navigate with the query string
                navigate(`/Invoice?${SecqueryString}`);
                if (!response.response) {
                 
                 }else{
                   console.log(response.response.data);
                   console.log(response.response.status);
                   console.log(response.response.headers);
                 }  if (response.request) {
                   console.log(response.request);
                 } else {
                   console.log('Error', response.message);
                 }
                 console.log(response.config);
                 setReastAmount('')
                 setpopupModal(false)
                 
                } 
               
          }
      
    const calculateTotals = () => {
        // Calculate total PartCost
const totalPartCost = repairOrder.reduce((acc, detail) => {
    const partCost = (parseFloat(detail.PartCost) || 0) * (parseInt(detail.PartQuantities) || 0);
    return acc + partCost;
}, 0);

        // Sum ServiceCost
        const totalServiceCost = repairOrder.reduce((acc, detail) => {
            const serviceCost = parseFloat(detail.ServiceCost) || 0; // Convert to number or default to 0
            return acc + serviceCost;
        }, 0);
    
        // Calculate combined total 
       
        const combinedTotal = totalPartCost + totalServiceCost; // ++CheckPrice
    
        return { totalPartCost, totalServiceCost, combinedTotal };
    };
    return (
        <>
                <ToastContainer />

        <div className="container">
        
            <div className="card">
            <Link to='/Orderslist' style={{ padding :"30px" ,display: 'flex', alignItems: 'center', position: 'absolute', left: '0px' }}>
  رجوع
  <i className="fa-solid fa-circle-arrow-left  me-3  fa-2xl"></i></Link>
{/* 
  <div  style={{ padding :"20px" , paddingTop :'70px' ,display: 'flex', alignItems: 'center', position: 'absolute', left: '0px' }}>
{ MainOrder.RepairStatus	 !="مكتملة" && MainOrder.RepairStatus!="تم التسليم" ?(
                                                        
                                                        <button className="btn btn-success m-2" onClick={() => مكتملة()}>RepairOrder مكتملة</button>
                            
                                                                                           ) :null}
                                                                                         
           </div> */}
            <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">   

<div className="tbl-caption">
<h4 className="heading ms-3">تعديل طلب الصيانة </h4>
<div >

                                                                                          {/* MainOrder.RepairStatus ==="مكتملة" ?(
                                                        <button className="btn  btn-secondary m-2"  onClick={(e) => orderlist(repairOrderId)}>Car Delivery </button>
                                                                                           ):null*/}
       </div> 
        

        
       </div>
       {/* <div style={{ border: "1px dashed black", padding: "10px", marginRight:'20px',marginLeft:' 20px'}}>
    <div className="row">
        <div className="col-md-3  ">
            <p><strong> اسم الزبون:</strong> {MainOrder.customer.FirstName}</p>
            <p><strong> سعر الكشف:</strong> {MainOrder.CheckPrice}</p>

            </div>        
         <div className="col-md-3">
        <p><strong>تاريخ الصيانة:</strong> {MainOrder.RepairDate}</p>
           <div className=" row d-flex " > <p><strong>التخفيض:</strong> <input
    type="number"
    className="form-control"
    id="Discount"
    name="Discount"
    min="0"
    defaultValue={MainOrder.Discount}
  onBlur={(e) => disccounfun(e.target.value)}
  /></p></div>

        </div>
        <div className="col-md-3">
                      <p><strong>رقم اللوحة:</strong> {MainOrder.vehicle.LicensePlate}</p>

            <p><strong>الاجمالي:</strong> ${MainOrder.TotalCost}</p>

           
        </div>
        <div className="col-md-3">
                    <p><strong>حالة الصيانة:</strong> {MainOrder.RepairStatus}</p>

         { MainOrder.RepairStatus	 ==  "انتظار"  ?(

                <button className="btn btn-sm btn-success me-1" onClick={() => Completed4()}>  بدأ عملية الصيانه</button> ) :null}

         { MainOrder.RepairStatus	 !="مكتملة" &&  MainOrder.RepairStatus!="تم التسليم"  && MainOrder.RepairStatus	 !=  "انتظار" ?(
                                                        
                                                        <button className="btn btn-sm btn-success" onClick={() => Completed()}>تغير الحالة الى  مكتملة</button>
                            
                                                                                           ) :null}
    </div> </div>
     <div className="row">
  <div className="col-md-6 ">
         <div className="    d-flex ">
             <p><strong> ملاحظات:</strong> </p>
             <textarea
  className="form-control mx-3 sm"
  value={Notes}
  name="Notes"
  onChange={(e) => setNotes(e.target.value)}
/>
                <Link to className="btn btn-success btn-sm m-3 "
                    onClick={handleAddNote}

                       style={{  width: '120px'}}                                            >+ اضف ملاحظة 
                                  
                                </Link> 
                 </div></div>
     </div>
</div> */}
<div
  style={{
    border: "1px dashed black",
    padding: "15px",
    margin: "20px",
    borderRadius: "8px",
  }}
>
  <div className="row gy-3">

    {/* العمود 1 */}
    <div className="col-md-3">
      <p><strong>اسم الزبون:</strong> {MainOrder.customer.FirstName}</p>

      <div className="input-group input-group-sm mb-2 "  style={{ direction:"ltr", maxWidth: "220px"  }}>
  <input 
    type="number"
    className="form-control"
    value={checkPrice}
    onChange={(e) => setCheckPrice(e.target.value)}
  />
    <span className="input-group-text"  >سعر الكشف</span>

</div>

    </div>


    {/* العمود 2 */}
    <div className="col-md-3">
      <p><strong>تاريخ الصيانة:</strong> {MainOrder.RepairDate}</p>

      <div className="input-group input-group-sm mb-2 "  style={{ direction:"ltr", maxWidth: "220px"  }}>
  <input
    type="number"
    className="form-control"
    value={Discount}
    onChange={(e) => setDiscount(e.target.value)}
  />  <span className="input-group-text"direction =" ltr">التخفيض</span>

</div>

    </div>


    {/* العمود 3 */}
    <div className="col-md-3">
      <p><strong>رقم اللوحة:</strong> {MainOrder.vehicle.LicensePlate}</p>
      <p><strong>الإجمالي:</strong> ${MainOrder.TotalCost}</p>
    </div>


    {/* العمود 4 */}
    <div className="col-md-3">
      <p><strong>حالة الصيانة:</strong> {MainOrder.RepairStatus}</p>

      {MainOrder.RepairStatus == "انتظار" && (
        <button className="btn btn-sm btn-success me-1" onClick={Completed4}>
          بدأ عملية الصيانة
        </button>
      )}

      {MainOrder.RepairStatus != "مكتملة" &&
        MainOrder.RepairStatus != "تم التسليم" &&
        MainOrder.RepairStatus != "انتظار" && (
          <button className="btn btn-sm btn-success" onClick={Completed}>
            تغيير الحالة إلى مكتملة
          </button>
        )}
    </div>
  </div>


  {/* الملاحظات */}
  <div className="row mt-3">
    <div className="col-md-9 d-flex">
      <label className="form-label ms-3"><strong>ملاحظات</strong></label>
      <textarea
        className="form-control"
        rows="1"
        defaultValue={Notes}
        onChange={(e) => setNotes(e.target.value)}
      />
    </div>

    {/* زر الحفظ */}
    <div className="col-md-3 d-flex align-items-end">
      <button
        className="btn btn-primary  "
        onClick={updateOrderInfo}
        disabled={loading}
      >
         حفظ التعديلات
      </button>
    </div>
  </div>
</div>

                <div className="card-body px-0 pb-0">
                    <Tab.Container defaultActiveKey={'Social'}>
                        <Nav as="ul" className="nav nav-pills success-tab" id="pills-tab" role="tablist">
                            <Nav.Item as="li" >
                                <Nav.Link as="button"  style={{width:'100px'}} eventKey={'Social'}>
                                    <span>الخدمات</span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as="button" style={{width:'100px'}}eventKey={'Social1'}>
                                    <span>قطع الغيار</span>
                                </Nav.Link>
                            </Nav.Item>

                        </Nav>
                        <Tab.Content>
                            <Tab.Pane eventKey={'Social'}>
                           
                                <Form onSubmit={handleSubmit}>
                                { MainOrder.RepairStatus	 != "مكتملة" && MainOrder.RepairStatus	 != "تم التسليم" ?(
                                     <Link to className="btn btn-warning btn-sm mx-3 mb-3"
                     onClick={()=> invite.current.showInviteModal()}
                       style={{  width: '120px'}}                                            >+ اضف خدمة 
                                  
                                </Link>  ):null}
                                { MainOrder.RepairStatus	 !="مكتملة"  &&  MainOrder.RepairStatus	 != "تم التسليم" ?(
                                      <Button type="submit" className="btn btn-primary btn-sm mx-2 mb-3">حفظ التعديلات</Button>
                                ):null}
                                    <div className="table-responsive">
                                        <table className="table  card-table border-no success-tbl">
                                             <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

                                                <tr>
                                                     <th>اسم الخدمة </th>
                                                    <th>الفني</th>
                                                    <th>ساعات العمل</th>
                                                    <th> حالة الطلب</th>
                                                    <th> تكلفةالخدمة </th>
                                                    <th>ملاحظات</th>
                                                    <th>عمليات</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {repairOrder.map((detail, index) => (
                                                    detail.ServiceID ? (
                                                        <tr key={detail.RepairDetailID}>
                                                             <td>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ServiceID"
                                                                    value={detail.service.ServiceName}
                                                                    onChange={(event) => handleChange(index, event)}
                                                                />
                                                            </td>
                                                            <td             >
                               
                               <select className="default-select form-control  " name="TechnicianID" defaultValue={detail.technician?.TechnicianID || ""}
                          onChange={(event) => handleChange(index, event)}
 >
                           <option data-display="Select" >{detail.technician?.FirstName || "Not Assigned"}</option>
                            {technicians.map(tech => (
                                                                    <option key={tech.TechnicianID} value={tech.TechnicianID}>
                                                                        {tech.FirstName}  
                                                                    </option>
                                                                ))}
                              
                         </select>
                             </td>
                                                             
                                                            <td>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="LaborHours"
                                                                    value={detail.LaborHours}
                                                                    onChange={(event) => handleChange(index, event)}
                                                                />
                                                            </td>
                                                            <td>
                                                            <Form.Select
                                                            className="default-select form-control  "
    name="Status"
    value={detail.Status || ""}
    onChange={(event) => handleChange(index, event)}
>
     <option value="انتظار">انتظار</option>
    <option value="قيد العمل">قيد العمل</option>
    <option value="معلقة">معلقة </option>
    <option value="مكتملة">مكتملة</option>
    <option value="فشل">فشل</option>
     <option value="ملغاة">ملغاة</option>
</Form.Select>
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ServiceCost"
                                                                    value={detail.ServiceCost}
                                                                    onChange={(event) => handleChange(index, event)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    as="textarea"
                                                                    name="Notes"
                                                                    value={detail.Notes}
                                                                    onChange={(event) => handleChange(index, event)}
                                                                />
                                                            </td>
                                                            <i className="fas fa-trash-alt m-4 me-4" onClick={() => handleDelete(detail.RepairDetailID)}></i>

                                                        </tr>
                                                    ) : null
                                                ))}
                                            </tbody>
                                        </table></div>
                                

                                </Form>
                            </Tab.Pane>
                            <Tab.Pane eventKey={'Social1'}>
                            
                                <Form onSubmit={handleSubmit}>
                                { MainOrder.RepairStatus	 != "مكتملة" && MainOrder.RepairStatus	 != "تم التسليم" ?(
                                     <Link to className="btn btn-warning btn-sm mx-3 mb-3"
                     onClick={()=> invite2.current.showInviteModal()}
                       style={{  width: '120px'}}                                            >+ اضف قطع غيار 
                                  
                                </Link>  ):null}
                                { MainOrder.RepairStatus	 !="مكتملة"  &&  MainOrder.RepairStatus	 != "تم التسليم" ?(
                                      <Button type="submit" className="btn btn-primary btn-sm mx-2 mb-3">حفظ التعديلات</Button>
                                ):null}
                                    <div className="table-responsive">
                                        <table className="table  card-table border-no success-tbl">
                                             <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

                                                <tr>
                                                     <th>اسم القطعة</th>
                                                    <th>الكمية</th>
                                                    <th>سعر القطعة</th>
                                                    <th>عمليات</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {repairOrder.map((detail, index) => (
                                                    detail.PartID ? (
                                                        <tr key={detail.RepairDetailID}>
                                                             <td>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="PartID"
                                                                    value={detail.parts.PartName}
                                                                    onChange={(event) => handleChange(index, event)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="PartQuantities"
                                                                    value={detail.PartQuantities}
                                                                    onChange={(event) => handleChange(index, event)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="PartCost"
                                                                    value={detail.PartCost}
                                                                    onChange={(event) => handleChange(index, event)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <i className="fas fa-trash-alt m-4 me-4" onClick={() => handleDelete(detail.RepairDetailID)}></i>
                                                            </td>
                                                        </tr>
                                                    ) : null
                                                ))}
                                            </tbody>
                                        </table></div>

                                </Form>
                            </Tab.Pane>
                           
                        </Tab.Content>
                    </Tab.Container>

                </div>
            </div>

            </div>

        </div>
        <Modal className="fade bd-example-modal-sm" size="sm" id="exampleModal1" show={popupModal} centered>
        <div className="modal-content">
          <div className="modal-body">
            <div className="col-sm-12">
              <div>
            <label className="form-label">القيمة المبقية : {reastAmount}</label>
</div>
<div>
              <label className="form-label">ادخل باقي القيمة<span className="text-danger">*</span></label>
</div>
              <input type="text"
                className="form-control"
                defaultValue=''

                //placeholder="ادخل قيم عددية صحيحه  فقط"
                required
                id="inputcity"
                name="city"
                onChange={(e) =>setAmount(e.target.value) } ></input>
                 
            </div>
            <div style={{color:"red"}}>{Err}</div>
            <div className="card-footer" >

              <button type="button" className="btn btn-primary light mx-1" onClick={handleEdit}>اضف</button>

              <button type="button" className="btn btn-danger light"onClick={()=>setpopupModal(false)}>اغلاق</button>
            </div>
          </div>
        </div>

      </Modal>
      <InviteCustomer
      ref={invite} 
      data={MainOrder}
      fetchRepairOrder={fetchRepairOrder}
      /> 
       <InviteCustomer2
      ref={invite2} 
      data={MainOrder}
      fetchRepairOrder={fetchRepairOrder}

      /> 
        </>
    );
};

export default EditRepairOrder;
